import React, { Component } from 'react';
import Link from 'gatsby-link';

import Cta from 'marketing-website/components/modules/Cta/CtaDefault';
import Page from 'marketing-website/components/modules/Page';
import Whitespace from 'marketing-website/components/commons/Whitespace';
import MediaFeature from 'marketing-website/components/modules/Media/MediaFeature';
import Video from 'marketing-website/components/modules/Integrations/Video';

import assets from 'marketing-website/configs/pages/features/wireframing/assets.js';

import Button from '@marvelapp/marvel-ui/button';
import Align from '@marvelapp/marvel-ui/align';
import { InlineGrid } from '@marvelapp/marvel-ui/grid';
import Heading from '@marvelapp/marvel-ui/heading';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';

import ExperimentBlock from '../wireframing/ExperimentBlock';
import MobileBlock from '../wireframing/MobileBlock';

const PAGE_COLOR = 'purple';

class FeatureWireframing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoOpen: false,
    };
  }

  render() {
    const buttons = [
      {
        text: 'Sign up free',
        link: '/signup/',
        styles: {
          shape: 'rounded',
          minWidth: 160,
          size: 'large',
        },
      },
      {
        text: 'Explore Plans',
        link: '/pricing/',
        styles: {
          shape: 'rounded',
          size: 'large',
          minWidth: 160,
          kind: 'ghost',
        },
      },
    ];

    const childButton = (
      <Button size="large" shape="rounded" hover="green" kind="ghost">
        Watch video
      </Button>
    );

    const ctaBlock = (
      <InlineGrid startAfterS size="s" sizeS="s">
        <Link to="/signup/?next=/onboarding/wireframing/">
          <Button size="large" shape="rounded" hover="blue">
            Start wireframing for free
          </Button>
        </Link>
        <Video id={'zztrodskog'} childButton={childButton} />
      </InlineGrid>
    );

    return (
      <Page
        title="Wireframe - Free Rapid wireframe tool for iOS, Android & Desktop"
        meta={[
          {
            name: 'description',
            content:
              'Wireframe apps, websites and more with the thousands of assets, templates and assets from our wireframing tool, directly in your browser. Free forever!',
          },
          {
            name: 'keywords',
            content:
              'wireframe, wireframe tools, wireframing, wireframe app, mockup tool, wireframe software',
          },
        ]}
        header={{ isLight: false }}
        footer
      >
        <PageWrap size="l">
          <Whitespace size="s" sizeS="l" sizeM="xl" />

          <Spacing size="xl" type="padding" position="top">
            <Align type="center">
              <MaxWidth value={820}>
                <Heading tag="h1" weight="semibold" size="mega">
                  A wireframing tool that gets you to the best idea, fast
                </Heading>
              </MaxWidth>
              <Spacing size="s" type="padding" position="topBottom">
                <MaxWidth value={720}>
                  <Paragraph size="xxxl" color="slate">
                    Access hundreds of wireframe assets for every device. Simple
                    templates, designed to help you implement ideas quickly.
                  </Paragraph>
                </MaxWidth>
              </Spacing>
              <Spacing size="s" type="padding" position="top">
                <Spacing size="l" type="padding" position="bottom">
                  {ctaBlock}
                </Spacing>
              </Spacing>
            </Align>
          </Spacing>

          <MediaFeature
            {...assets.canvas}
            backgroundColor={PAGE_COLOR}
            patternLeft="34.5%"
            patternTop="30%"
          />

          <Whitespace size="l" />
          <MobileBlock color={PAGE_COLOR} />
          <ExperimentBlock />
          <Cta
            maxWidth={480}
            title="Join over 2 million people wireframing with Marvel. Get started for free."
            buttons={buttons}
          />
        </PageWrap>
      </Page>
    );
  }
}

export default FeatureWireframing;



// WEBPACK FOOTER //
// ./src/pages/features/wireframe-and-design-ux/index.js